import { checkEmail } from "./productTools";
import Swal from "sweetalert2";

interface cartProductData {
	productId: number;
	services: object;
}
interface cart {
	byOneClick: (productId: number, data: cartProductData) => void;
	delete: (productId: number) => void;
	clear: () => void;
	add: (data: cartProductData) => void;
	makeOrder: (data: any) => void;
	getCartData: () => void;
	onChange: () => void;
	active: (prod_id: any) => void;
}
interface ISomeObject {
	[key: string]: object;
}

const fixPrice = (price: number | string) => {
	let res = price;
	const priceSt = price + "";
	const isFloat = priceSt.split(".")[1];
	if (isFloat && isFloat.length > 2) {
		res = parseFloat(priceSt).toFixed(2);
	}
	// console.log('fixPrice' , res);
	return res;
};
let itogo = "Итого";
if ((<any>window).lang && (<any>window).lang.itogo) {
	itogo = (<any>window).lang.itogo;
}
// cart api
(() => {
	let isInit = false;
	document.addEventListener("DOMContentLoaded", () => {
		init();
	});
	setInterval(() => {
		if (!isInit) {
			if (document.readyState === "complete") {
				init();
			}
		}
	}, 400);
	const init = () => {
		console.log("cart DOMContentLoaded init");
		//@ts-ignore
		if (isInit === true) return false;
		//@ts-ignore
		isInit = true;

		const jsLoader = document.querySelector<HTMLElement>(`.jsLoader`);
		const jsPopupCart = document.querySelector(`.jsPopupCart`);
		const jsTotalPrice = document.querySelectorAll(`.jsTotalPrice`);
		(<any>window).cartActiveProdIndex = 0;
		const cart: cart = {
			byOneClick: (productId, data) => {
				// console.log(productId, data);
			},
			add: (data) => {
				console.log("add", data);
				// alert('add')

				let cartData: ISomeObject = {};
				if (localStorage.cart) {
					cartData = JSON.parse(localStorage.cart);
				}
				// console.log("cartData", cartData);
				cartData[data.productId] = data;

				localStorage.setItem("cart", JSON.stringify(cartData));

				if (jsPopupCart) {
					setTimeout(() => {
						jsPopupCart.classList.add("is-open");
					}, 200);
				}
				cart.onChange();
			},
			delete: (productId) => {
				// console.log("delete", productId);
				let cartData: ISomeObject = {};
				if (localStorage.cart) {
					cartData = JSON.parse(localStorage.cart);
				}
				// console.log("cartData", cartData);
				delete cartData[productId];

				localStorage.setItem("cart", JSON.stringify(cartData));
				cart.onChange();
			},
			clear: () => {
				localStorage.setItem("cart", JSON.stringify({}));
				cart.onChange();
			},
			active: (index: any) => {
				console.log("active", index);
				// (<any>window).cartActiveProdIndex = index;
				const products = document.querySelectorAll(
					`.jsSctCart .jsCartProduct`
				);
				const productsCompact = document.querySelectorAll(
					`.jsSctCart .jsCartProductCompact`
				);

				products.forEach((item) => {
					item.classList.remove("isActive");
				});
				products[index].classList.add("isActive");

				productsCompact.forEach((item) => {
					item.classList.remove("isActive");
				});
				productsCompact[index].classList.add("isActive");

				// cart.onChange();
			},
			onChange: () => {
				// console.log("onChange");
				// alert('onChange')
				if (!localStorage.cart) {
					return false;
				}
				// localStorage.cart = ``;

				const cartData = JSON.parse(localStorage.cart);
				// console.log('cartData' , cartData);
				const productsCout = Object.keys(cartData).length;
				const jsCartTotalCoutNodes =
					document.querySelectorAll<HTMLElement>(`.jsCartTotalCout`);
				const jsCartEmptyNode = <HTMLElement>(
					document.querySelector(`.jsCartEmpty`)
				);
				const jsCartInfoNode = <HTMLElement>(
					document.querySelector(`.jsCartInfo`)
				);
				const jsCartInfoEndNodes =
					document.querySelectorAll<HTMLElement>(`.jsCartInfoEnd`);

				if (jsCartTotalCoutNodes) {
					jsCartTotalCoutNodes.forEach((item) => {
						item.innerHTML = `${productsCout}`;
					});
					jsCartInfoEndNodes.forEach((item) => {
						item.style.display = `none`;
					});
					const end: number =
						parseInt((productsCout + "").slice(-1)) || 0;
					if (jsCartEmptyNode && jsCartInfoNode) {
						jsCartInfoNode.style.display = "flex";
						if (productsCout === 0) {
							jsCartEmptyNode.style.display = "flex";
							jsCartInfoNode.style.display = "none";
						} else if (productsCout > 0) {
							jsCartEmptyNode.style.display = "none";
							jsCartInfoNode.style.display = "flex";
							if (productsCout > 9 && productsCout < 20) {
								jsCartInfoEndNodes[2].style.display = "flex";
							} else {
								// console.log('else' ,end);
								if (end === 1) {
									jsCartInfoEndNodes[0].style.display =
										"flex";
								}
								if (end === 2 || end === 3 || end === 4) {
									jsCartInfoEndNodes[1].style.display =
										"flex";
								}
								if (
									end === 5 ||
									end === 6 ||
									end === 7 ||
									end === 8 ||
									end === 9 ||
									end === 0
								) {
									jsCartInfoEndNodes[2].style.display =
										"flex";
								}
							}
						}
					}
				}
				const jsInCartButtonLabel =
					document.querySelectorAll(`.jsInCartButtonLabel`);

				if (jsInCartButtonLabel) {
					jsInCartButtonLabel.forEach((item) => {
						if (cartData[(<any>item).dataset.id]) {
							item.classList.add("is-in-cart");
						} else {
							item.classList.remove("is-in-cart");
						}
					});
				}

				// cartPage
				const jsSctCart = document.querySelector(`.jsSctCart`);
				const jsDataProductsCout =
					document.querySelector<HTMLElement>(`.jsDataProductsCout`);

				if (jsSctCart) {
					const jsCartProducts =
						document.querySelector(`.jsCartProducts`);
					if (jsCartProducts) {
						jsCartProducts.innerHTML = `${productsCout}`;
						if (jsDataProductsCout) {
							jsDataProductsCout.dataset.count = `${productsCout}`;
						}
						let cartInnerHtml = ``;
						let productsCompact = `<div class="cart-compact-products">`;
						let productsIds: any[] = [];
						let needFetch = false;

						let isCompact = false;
						if (Object.keys(cartData).length > 3) {
							isCompact = true;
						}
						Object.keys(cartData).forEach((productId) => {
							productsIds.push(productId);
							// console.log(
							// 	"window,products",
							// 	(<any>window).products
							// );
							if ((<any>window).products) {
								const prod = (<any>window).products.filter(
									(item: any) => {
										return item.id == productId;
									}
								)[0];
								// console.log('prod' , prod);
								if (!prod) {
									needFetch = true;
								}
							} else {
								needFetch = true;
							}
						});
						// needFetch = true;

						const render = () => {
							// console.log("render");
							if ((<any>window).products) {
								let totalPrice = 0;
								Object.keys(cartData).forEach(
									(id: any, index: number) => {
										const prod = (<any>(
											window
										)).products.filter((item: any) => {
											return item.id == id;
										})[0];
										const prodServices =
											cartData[id].services;
										let servicesNode = ``;
										console.log("prod.id", prod.id);
										if (
											![5223, 4552, 4847, 4269].includes(
												parseInt(prod.id)
											)
										) {
											Object.keys(prodServices).map(
												(id: any) => {
													prod.servicesPrice = 0;
													// console.log('asd' , prod , prod.service_all );
													// totalPrice += parseInt(prod.servicesPrice) || 0;
													totalPrice +=
														parseFloat(
															prod.service_all[id]
																.price
														) || 0;
													servicesNode += `
                                            <div class="cart-product--service">
                                                <span class="name">${
													prod.service_all[id].name
												}</span>
                                                <span class="comment">${
													cartData[prod.id].services[
														id
													].comment
												}</span>
                                                <span class="price">+ ${fixPrice(
													prod.service_all[id].price
												)} ${
														(<any>window).currency
															.sign
													} </span>
                                             </div>
                                            `;
												}
											);
										}
										totalPrice +=
											parseFloat(prod.price) || 0;
										// totalPrice +=
										// 	parseInt(prod.servicesPrice) || 0;
										let isActive = false;
										if (0 === index) {
											isActive = true;
										}
										cartInnerHtml += `
                                            <div class="cart-product jsCartProduct ${
												isActive ? "isActive" : ""
											}">
                                                <div class="cart-product--main-wrap">
                                                    <div class="cart-product--index"> ${
														index + 1
													} </div>
                                                    <img class="cart-product--image" src="${
														prod.image
													}" />
                                                    <div class="cart-product--middle-wrap">
                                                        <a href="/products/${
															prod.id
														}" class="cart-product--title color-secondary"> ${
											prod.title
										} </a>
                                                        <div class="cart-product--title"> ${
															prod.type
														} </div>
                                                        
                                                    </div>
                                                    <div class="cart-product--price">
                                                        <div>  
                                                            <span class='old-price'>${fixPrice(
																prod.old_price
															)}
                                                            
                                                            </span>
                                                            <span class='discount-percent'>-${
																prod.discount_percent
															}% </span>
                                                        ${fixPrice(
															prod.price
														)} ${
											(<any>window)?.currency?.sign || ""
										}.</div>
                                                        <div>${
															prod.servicesPrice >
															0
																? "+ " +
																  fixPrice(
																		prod.servicesPrice
																  ) +
																  (<any>window)
																		.currency
																		.sign
																: ""
														}</div>
                                                        
                                                    </div>
                                                    
                                                    <div class="cart-product--delete" onclick="cart.delete(${
														prod.id
													})"> 
                                                    <svg  width="24" height="24" viewBox="0 0 24 24" ><use xlink:href="#delete_forever"></use></svg>
                                                    </div>
                                                </div>

                                                <div class="cart-product--services">${servicesNode}</div>
                                            </div>
                                            <hr>
                                        `;
										productsCompact += `<div class="cart-product--compact jsCartProductCompact ${
											isActive ? "isActive" : ""
										}" onclick="cart.active(${index})">
                                        <div class="cart-product--index cart-product--compact-index"> ${
											index + 1
										} </div>
                                            <img class="" src="${prod.image}" />
                                        </div>`;
									}
								);
								if (
									isCompact &&
									jsCartProducts.classList.contains(
										"jsCartProductsInPopup"
									)
								) {
									productsCompact += `</div>`;
									cartInnerHtml += productsCompact;
								}
								cartInnerHtml += `<div class='cart--products-total-price'> ${itogo}: <span> ${fixPrice(
									totalPrice
								)} </span> ${
									(<any>window)?.currency?.sign || ""
								}.</div>`;
								// cartInnerHtml +=`<div class='total-price'>${totalPrice}</div>`

								jsCartProducts.innerHTML = cartInnerHtml;

								if (
									jsCartProducts.classList.contains(
										"jsCartProductsInPopup"
									)
								) {
									if (isCompact) {
										jsCartProducts.classList.add(
											"isCompact"
										);
									} else {
										jsCartProducts.classList.remove(
											"isCompact"
										);
									}
								}
								if (jsTotalPrice) {
									jsTotalPrice.forEach((item) => {
										(<any>item).innerHTML = totalPrice;
									});
								}
							}
						};
						// console.log("needFetch", needFetch);
						if (needFetch) {
							// console.log("fetch");
							if ((<any>window).cartTimer === true) {
								return false;
							}
							(<any>window).cartTimer = true;
							setTimeout(() => {
								(<any>window).cartTimer = false;
								cart.onChange();
							}, 1000);

							fetch(`/ajax-api/`, {
								method: "post",
								body: JSON.stringify({
									action: "getProduct",
									productsIds: productsIds,
								}),
							})
								.then((res) => res.json())
								.then((res) => {
									if (res.products) {
										(<any>window).products = res.products;
										(<any>window).currency = res.currency;
										cart.onChange();
									}
									console.log("fetch products", res);
								});
						} else {
							render();
						}
					}
				}
				// endCartPage
			}, //onChange
			makeOrder: async (event) => {
				event.preventDefault();
				let formData: any = cart.getCartData();
				console.log("formData", formData);
				if (!(await checkEmail(formData.email))) return;
				formData.action = "makeOrder";
				// alert(formData.payment_method_id);
				if (!formData.payment_method_id) {
					const jsPayment = document.querySelector<any>(`.jsPayment`);
					jsPayment.MDCSelect.selectedIndex = -1;
					jsPayment.scrollIntoView({
						behavior: "smooth",
						block: "center",
					});
					// console.log( 'MDCSelect' ,(<any>document.querySelector(`.jsPayment`)).MDCSelect);
					// (<any>document.querySelector(`.jsPayment`)).MDCSelect.setRequired();
					return false;
				}
				if (jsLoader) {
					jsLoader.classList.add("isOpen");
				}
				formData.comment =
					formData.comment +
					"" +
					(localStorage.getItem(`orderUpdateData`) || "");
				fetch(`ajax-api/`, {
					method: "post",
					body: JSON.stringify(formData),
				})
					.then((res) => res.json())
					.then((res) => {
						if (res.error) {
							jsLoader?.classList.remove("isOpen");
							Swal.fire({ icon: "error", text: res.error });
							return;
						}

						console.log("res makeOrder", res);
						localStorage.removeItem(`orderUpdateData`);
						if (res.order && res.order.url) {
							cart.clear();
							location.pathname = `/order/${res.order.url}`;
						} else {
							alert("error makeOrder");
						}
						if (jsLoader) {
							jsLoader.classList.remove("isOpen");
						}
					});
			},
			getCartData: () => {
				const jsSctCart = document.querySelector(`.jsSctCart`);
				if (jsSctCart) {
					let formData = (<any>window).formToObject(jsSctCart);
					const jsDelivery = document.querySelector(`.jsDelivery`);
					if (jsDelivery) {
						formData.delivery_id = parseInt(
							(<any>jsDelivery).MDCSelect.value + ""
						);
					}
					formData.payment_method_id = parseInt(
						(<any>document.querySelector(`.jsPayment`)).MDCSelect
							.value + ""
					);
					// formData.payment_method_id = 25;
					// if(localStorage.cart){
					formData.products = JSON.parse(localStorage.cart);
					// }
					// console.log('jsSctCart' , formData);
					return formData;
				} else {
					alert("error !jsSctCart");
				}
			},
		};
		cart.onChange();

		(<any>window).cart = cart;

		//
		const jsCheckCoupon = <HTMLInputElement>(
			document.querySelector(`.jsCheckCoupon`)
		);
		const jsIconDone = document.querySelector(`.jsIconDone`);
		const jsCouponHelperText =
			document.querySelector(`.jsCouponHelperText`);

		if (jsCheckCoupon && jsIconDone) {
			jsCheckCoupon.addEventListener("input", (event) => {
				const value = jsCheckCoupon.value;
				if (value && value.length > 3) {
					fetch(`/ajax-api/`, {
						method: "post",
						body: JSON.stringify({
							couponCode: value,
							action: "checkCoupon",
						}),
					})
						.then((res) => res.json())
						.then((res) => {
							const coupon = res.coupon;
							// alert(coupon);
							if (jsIconDone) {
								jsIconDone.classList.remove("is-error");
								if (coupon) {
									jsIconDone.classList.add("is-done");
									jsCouponHelperText && coupon.balance
										? (jsCouponHelperText.innerHTML =
												coupon.balance)
										: null;
								} else {
									jsIconDone.classList.remove("is-done");
									jsCouponHelperText
										? (jsCouponHelperText.innerHTML = ``)
										: null;
								}
							}
							// console.log('jsCheckCoupon' , value , coupon)
						});
				} //
			}); //input
			jsCheckCoupon.addEventListener("change", (event) => {
				const value = jsCheckCoupon.value;
				if (value && value.length > 3) {
					!jsIconDone.classList.contains("is-done")
						? jsIconDone.classList.add("is-error")
						: jsIconDone.classList.remove("is-error");
				}
			}); //change
		} //jsCheckCoupon && jsIconDone

		const jsInputsService = document.querySelectorAll(`.jsInputService`);
		const jsShowOnDelivery = document.querySelectorAll(`.jsShowOnDelivery`);
		if (jsInputsService && jsShowOnDelivery) {
			jsInputsService.forEach((item) => {
				item.addEventListener("change", () => {
					//inputs
					const checkedNode = <HTMLInputElement>(
						document.querySelector(`.jsInputService:checked`)
					);
					if (checkedNode && checkedNode.value !== "3") {
						jsShowOnDelivery.forEach((item) => {
							item.classList.remove("is-hidden");
						});
						const jsPaymentOption = <HTMLElement>(
							document.querySelector(
								`.jsPaymentOption[data-value="${13}"]`
							)
						);
						//console.log('change', jsPaymentOption);
						jsPaymentOption.classList.remove("disabled");

						document.querySelector<any>(
							`.jsDelivery`
						).MDCSelect.value = "7"; //почта России
					} else {
						jsShowOnDelivery.forEach((item) => {
							item.classList.add("is-hidden");
						});
						const jsPaymentOption = <HTMLElement>(
							document.querySelector(
								`.jsPaymentOption[data-value="${13}"]`
							)
						);
						//console.log('change', jsPaymentOption);
						jsPaymentOption.classList.add("disabled");
						document.querySelector<any>(
							`.jsDelivery`
						).MDCSelect.value = "14"; //Скачать онлайн
					}
					//payment options

					//
				});
			});
		}

		//
	}; // DOMContentLoaded
})();
// END cart api
